export const dropdownMenuTriggerStyles = {
  borderRadius: '$inputField',
  marginInlineStart: '$half',
  '&:hover': {
    borderColor: '$inputBorderHovered',
    backgroundColor: '$inputBackgroundHovered',
    color: '$tertiaryTextDefault',
  },
  '&:active': {
    borderColor: '$inputBorderPressed',
    backgroundColor: '$inputBackgroundPressed',
    color: '$tertiaryTextDefault',
  },
};

export const dropdownMenuContentStyles = {
  marginBlockStart: '$quarter',
  backgroundColor: '$surfaceBackgroundPrimary',
  borderRadius: '$extraLarge',
  border: '$borderWidths$thin solid $interactiveBorderDefault',
  zIndex: '$dropdown',
  maxHeight: 'min(calc(100vh - 4.375rem), 25rem)', // 4.375rem buffer ensures menu doesn't touch screen edge incase someones browser is like teeny tiny!; 25rem maximum height for consistency- will normally be this height unless there are not many items
  overflowY: 'auto',
  // Custom scrollbar styling - much thinner
  '&::-webkit-scrollbar': {
    width: '2px',
  },

  // Firefox scrollbar styling - uses thin scrollbar that doesn't take much space
  scrollbarWidth: 'thin',
  // using a theme color here did not allow for the background to be transparent, so using rgba instead as the scrollbar color
  scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent',
};

export const dropdownMenuItemStyles = {
  borderBottom: 'solid $colors$onSurfaceBorderSubdued $borderWidths$thin',
  '&:first-child': {
    'border-top-left-radius': '$extraLarge',
    'border-top-right-radius': '0', // for scrollbar clipping
  },
  '&:last-child': {
    borderBottom: 'none',
  },
};
